import { Input, Select, message, Radio, Switch, Button, Spin } from "antd";
import React from "react";
import UploadImage from '../../components/uploadImg'
import config from '../../config/upload'
import Sku from '../../components/sku'
import api from "../../utils/api";

import Editor from '../../components/editor'
import BigImgBar from '../../components/editor/bigImgBar'
import BigImgView from '../../components/editor/bigImgView'
import SmallImgBar from '../../components/editor/smallImgBar'
import SmallImgView from '../../components/editor/smallImgView'
import TextBar from '../../components/editor/textBar'
import TextView from '../../components/editor/textView'
import ComponentType from '../../components/editor/ComponentType'
import _, { find, map } from 'lodash'

import './index.sass'

const { Option } = Select;

export default class GoodsEditor extends React.Component {
    constructor(props) {
        super(props)

        // console.log(props)

        this.state = {
            imageLoad: true,
            goods_name: '',
            fileList: [],
            main_img_flag: 0,
            specsVal: false,
            goodscostPrice: null,
            goodssalePrice: null,
            goodsCode: null,
            maxSaleNum: null,
            specsList: [],
            entities: [],
            classifys: [],
            member_type: '',
            loading: false,
            goodsContent: [],
            member_type: '',//初始分类

        }
    }


    componentDidMount() {

        this.getSpecs();
        this.getClassify();
        this.getProductInfo();

    }

    getSpecs = async () => {//获取商品规格列表
        let res = await api('get-specs', {});
        if (res.code === 200) {
            let allSpec = res.data;
            let list = allSpec.map((v, i) => {
                console.log(v)
                return {
                    id: v['id'],
                    name: v['name'],
                    values: v.values.map((sv) => {
                        console.log(sv)
                        return {
                            value: sv,
                            id: `${v['name'] + sv}`
                        }
                    })
                }
            });

            console.log(list)
            await this.setState({ specsList: [...list] });
        }
        //console.log(res)
    }


    getClassify = async () => {//获取分类
        let res = await api('get-cates');
        if (res.code === 200) {
            this.setState({
                classifys: res.data
            })
        }
    }

    openSpecs = async (e) => {//开启规格
        this.setState({
            specsVal: e
        })
    }


    selectonChange = (e) => {//选择分类
        console.log(e)
        this.setState({
            member_type: e
        })
    }


    delUploadImg = (index) => {//删除上传图片
        let { fileList, main_img_flag } = this.state;
        if (index == main_img_flag) {
            return message.error('不能删除主图')
        }
        if (index < main_img_flag) {
            main_img_flag -= 1;
        }
        fileList.splice(index, 1)
        this.setState({
            fileList,
            main_img_flag
        })
    }

    setMainImg = (index) => {//设为主图
        const { fileList } = this.state;

        let main_img = fileList[index];
        this.setState({ fileList, goods_image: main_img, main_img_flag: index })
    }

    fontImg = (index) => {
        let { fileList } = this.state

        if (index != 0) {
            fileList[index] = fileList.splice(index - 1, 1, fileList[index])[0];
        } else {
            fileList.push(fileList.shift());
        }

        this.setState({
            fileList
        })
    }

    backImg = (index) => {
        let { fileList } = this.state
        if (index != fileList.length - 1) {
            fileList[index] = fileList.splice(index + 1, 1, fileList[index])[0];
        } else {
            fileList.unshift(fileList.splice(index, 1)[0]);
        }
        this.setState({
            fileList
        })
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };

    handleChange = async ({ file }) => {
        await file
        const { fileList } = this.state;
        //let hide = null;
        if (file['response'] && file['response']['status']) {
            let data = file['response']['data']['url'];
            let list = fileList;
            list.push(data);

            if (list.length === 1) {
                this.setState({
                    goods_image: list[0]
                })
            }
            this.setState({ fileList: list });
            console.log(list, 'list-------------')
            message.success('上传成功！', 1);

        } else if (file['status'] && file['status'] == 'error') {
            //console.log(file,)
            message.error('上传失败！', 1);
        }

        this.setState({ imageLoad: true });

    };

    beforeUpload = (e) => {

        let type = e.type.includes('image');

        return new Promise((resolve, reject) => {
            if (!type) {
                message.error('格式不正确！')
                reject(false)
            } else if (e.size > 2000000) {
                message.error('图片尺寸应小于2MB')
                reject(false)
            } else {
                message.loading('上传图片中...', 1)
                this.setState({
                    imageLoad: false
                })
                resolve(e)
            }
        })
    }

    getEditor = (e) => {//updateEditor  editor
        //console.log(e)
    }

    scrollToBottom() {
        if (this.messagesEnd) {
            const scrollHeight = this.messagesEnd.scrollHeight;//里面div的实际高度  2000px
            const height = this.messagesEnd.clientHeight;  //网页可见高度  200px
            const maxScrollTop = scrollHeight - height;
            this.messagesEnd.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
            //如果实际高度大于可见高度，说明是有滚动条的，则直接把网页被卷去的高度设置为两个div的高度差，实际效果就是滚动到底部了。

            //console.log('scrollHeight',scrollHeight)
        }
    }

    addGoods = async () => {//添加商品

        let { props } = this;

        let isEditor = false
        let product_id = ''

        if (props.location.state && props.location.state.isEditor) {
            isEditor = true
            product_id = props.location.state.id
        }

        let { goods_name, fileList, entities, imageLoad, member_type, specsVal, goodssalePrice, goodscostPrice, goodsCode, maxSaleNum } = await this.state;

        if (!imageLoad) return message.error('请等待图片上传完成！')


        let param = {
            name: goods_name,
            images: fileList,
            cates: [member_type],
            specs: []
        }



        let edom = this.refs.edom;//编辑商品 component
        let edomCont = edom['state']['components'];
        let editorData = [];
        edomCont.map((v, i) => {
            //console.log(v)
            let data = {};
            //data[v['type']] = v['data'];
            // if (v.type === 'image_b') {
            //     data.type = 'bigImage'
            // } else if (v.type === 'image_s') {
            //     data.type = 'smallImage'
            // } else {
            //     data.type = 'text'
            // }
            data.type = v.type;
            data.value = v['data']
            editorData.push(data);
        })

        if (edomCont.length) {
            param['details'] = editorData;
        }

        //return




        let SkuList
        if (specsVal) {
            SkuList = this.refs.SkuList ? this.refs.SkuList.state['specEntities'] : [];
            SkuList.map((v, i) => {
                v['price'] = v.sell_price;
                v['stock'] = v.stock_num;
                v['code'] = v['entity_code'] ? v['entity_code'] : ''

                // v['spec'] = {};
                v['specs'] = [];


                let spec_values = v['spec_values'];

                let spec_arr = [];

                spec_values.map(j => {
                    //let specValue = j['specValue']
                    //v['spec'][j['specId']] = specValue['id']


                    v['specs'].push({
                        spec_name: j['specName'],
                        value_name: j['specValue']['value']
                    })

                    spec_arr.push(j['specValue']['value']);

                    param['specs'].push({
                        name: j['specName'],
                        values: spec_arr
                    })
                })
            })

            param['entities'] = [...SkuList]

        } else {
            param['entities'] = [
                {
                    price: goodssalePrice,
                    market_price: goodscostPrice,
                    stock: maxSaleNum,
                    code: goodsCode
                }
            ]
        }


        if (isEditor) {
            param['product_id'] = product_id
        }


        let res = null;


        if (isEditor) {
            res = await api('update-product', param)
        } else {
            res = await api('add-product', param)
        }


        console.log(res)


        if (res.code === 200) {
            if (isEditor) {
                message.success('修改商品成功！')

            } else {
                message.success('创建商品成功！')

            }
        } else {
            message.error(res.message)
        }

        console.log(fileList, res)

    }



    getProductInfo = async () => {//获取商品详情

        let { state } = this.props.location;
        let { specsList } = await this.state

        if (!state.id) return

        this.setState({
            loading: true
        })

        let param = {
            product_id: state.id
        }

        let res = await api('get-product-info', param)

        if (res.code === 200) {


            let details = res.data;

            this.setState({
                loading: false,

                goods_name: details.name,
                fileList: details.images,
                member_type: details.cates[0]


            })

            console.log(details['entities'], 'details')


            if (details['entities']) {
                let specsVal = true
                let skuList = details['entities']
                let isNullkeys = details['entities'][0]['specs'] ? Object.values(details['entities'][0]['specs']) : [''];

                if (isNullkeys[0] == '') {
                    specsVal = false;
                    skuList = []
                }
                this.setState({
                    specsVal,
                    skuList,
                    goodssalePrice: details['entities'][0]['price']
                })
            }



            let allDetail = details;//详情

            let entities = allDetail['entities'];
            entities = entities ? entities : [];

            //console.log(allDetail,)

            if (entities && entities.length) {//有规格无值
                let isNullkeys = allDetail['entities'][0]['specs'] ? Object.values(allDetail['entities'][0]['specs']) : [''];
                if (isNullkeys[0] == '' || !isNullkeys[0]) {
                    entities = []
                }
            }



            //组装
            let newEntities = entities.map((v, i) => {

                return {
                    market_price: v['market_price'],
                    sell_price: v['price'],
                    stock_num: v['stock'],
                    spec_values: map(v['specs'], (spId, specd) => {
                        spId['specName'] = spId['spec_name']
                        spId['specValue'] = {
                            id: `${spId['spec_name'] + spId['value_name']}`
                        }

                        return {
                            specId: `${spId['spec_name']}`,
                            specName: spId['spec_name'],
                            specValue: {
                                id: `${spId['spec_name'] + spId['value_name']}`,
                                value: spId['value_name']
                            }
                        }
                    })
                };
            })

            this.setState({ entities: [...newEntities] });



            if (details.details) {

                let resarr = []

                details.details.map((item, index) => {
                    // let obj = `{ ${item.type}: ${item.value} }`
                    let obj = {
                        [item.type]: item.value
                    }

                    console.log(details.details, obj, 'details---------', typeof obj,)

                    resarr.push(
                        obj
                    )
                }
                )

                console.log(details.details, resarr, 'goodsContentgoodsContentgoodsContentgoodsContentgoodsContent')

                this.setState({
                    goodsContent: [...resarr]
                })
            }
        }

    }


    render() {

        let { props } = this;

        const EditorBar = [
            { title: '大图', barTemplate: BigImgBar, template: BigImgView, type: ComponentType.BIG_IMG },
            {
                title: '小图',
                barTemplate: SmallImgBar,
                template: SmallImgView,
                type: ComponentType.SMALL_IMG,
                data: { count: 3 }
            },
            { title: '文字', barTemplate: TextBar, template: TextView, type: ComponentType.TEXT }
        ]


        let { goods_name, fileList, main_img_flag, entities, goodscostPrice, goodssalePrice, maxSaleNum, specsList, classifys, imageLoad, loading, member_type, goodsContent } = this.state;

        const uploadProps = {
            action: `${config.apiUrl}/admin/upload/upload-image`,
            listType: "picture-card",
            name: 'file',
            accept: '.png,.jpg,.jpeg,.gif',
            showUploadList: false,
            onPreview: this.handlePreview,
            onChange: this.handleChange,
            beforeUpload: this.beforeUpload
        }

        return (
            <div className='goodsEditor'>

                {
                    loading ? (<Spin size="small" />) : (
                        <>
                            <div className='title'>
                                基本信息
                            </div>

                            <div className='line flex alignCenter'>
                                <label>商品名称：</label>
                                <Input value={goods_name} style={{ width: 280 }}
                                    onChange={(e) => {

                                        this.setState({ goods_name: e.target.value })

                                    }} placeholder='请输入商品名称、最多20字' maxLength={20} />
                                {
                                    !goods_name ? (
                                        <p className='tips warn'>请输入商品名称</p>
                                    ) : null
                                }
                            </div>

                            <div className='line flex alignCenter'>
                                <label>商品分类：</label>
                                <Select
                                    style={{ width: 280 }}
                                    showSearch
                                    placeholder="全部"
                                    value={member_type}
                                    optionFilterProp="children"
                                    onChange={(e) => { this.selectonChange(e) }}
                                    onSearch={(e) => { this.selectonSearch(e) }}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {
                                        classifys.map((item) =>
                                            <Select.Option key={item.id} lable={item.name} value={item.name}>
                                                {item.name}
                                            </Select.Option>
                                        )
                                    }
                                </Select>
                            </div>


                            <div className='line flex'>
                                <label>商品图片：</label>
                                <div>
                                    <div className='uploadImg flex'>
                                        <UploadImage
                                            uploadProps={uploadProps}
                                            files={fileList}
                                            deleteImg={(index) => {
                                                this.delUploadImg(index)
                                            }

                                            } setMainImg={(index) => {
                                                this.setMainImg(index)
                                            }}
                                            main_img={main_img_flag}
                                            fontImg={(index) => { this.fontImg(index) }}
                                            backImg={(index) => { this.backImg(index) }}
                                        />
                                    </div>

                                    <p style={{ marginLeft: 0, marginBottom: 4 }} className='tips warn'>请上传商品图片</p>

                                    <p className='advise'>建议尺寸：800x800，单张大小不超过2M，最多可上传10张</p>

                                </div>
                            </div>


                            <div className='line flex alignCenter'>
                                <label>是否冻品：</label>
                                <Radio.Group onChange={(e) => {
                                    this.setState({ frozenFoodValue: e.target.value })
                                }} value={this.state.frozenFoodValue}>
                                    <Radio value={'freezing'}>冻品</Radio>
                                    <Radio value={'cold'}>鲜品</Radio>
                                    <Radio value={'normal'}>常温品</Radio>
                                    <Radio value={'heat'}>其他</Radio>
                                </Radio.Group>
                            </div>


                            <div className='title'>
                                价格/规格
                            </div>

                            <div className='line '>


                                <div className='flex line alignCenter'>
                                    <label>开启规格：</label>
                                    <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked={false}
                                        checked={this.state.specsVal} onChange={this.openSpecs} />

                                    <div className='addSpecval'>
                                        开启即可添加规格与规格值
                                    </div>
                                </div>


                                {this.state.specsVal && specsList.length > 0 ? (
                                    <Sku ref='SkuList' specData={specsList} entities={entities}
                                        changeEntities={(entities) => {
                                            this.setState({ entities })
                                        }} />
                                ) : (

                                    <div>
                                        <div className='line flex alignCenter'>
                                            <label>商品编码：</label>
                                            <Input placeholder='请输入商品编码'
                                                style={{ width: 280 }}
                                                disabled={this.state.specsVal}
                                                className='needInput'
                                                value={this.state.goodsCode} onChange={(e) => {
                                                    this.setState({ goodsCode: e.target.value })
                                                }} />
                                        </div>

                                        <div className='line flex alignCenter'>
                                            <label>商品售价：</label>
                                            <Input placeholder='请输入商品售价'
                                                style={{ width: 280 }}
                                                disabled={this.state.specsVal}
                                                className='needInput'
                                                value={this.state.goodssalePrice} onChange={(e) => {
                                                    this.setState({ goodssalePrice: e.target.value })
                                                }} />
                                            {
                                                !goodssalePrice ? (
                                                    <p className='tips warn'>请输入商品售价</p>
                                                ) : null
                                            }
                                        </div>

                                        <div className='line flex alignCenter'>
                                            <label>商品划线价：</label>
                                            <Input placeholder='商品划线价'
                                                style={{ width: 280 }}
                                                disabled={this.state.specsVal}
                                                className='needInput'
                                                value={this.state.goodscostPrice} onChange={(e) => {
                                                    this.setState({ goodscostPrice: e.target.value })
                                                }} />


                                        </div>

                                        <div className='line flex alignCenter'>
                                            <label>最大可售数量：</label>
                                            <Input placeholder='最大可售数量'
                                                style={{ width: 280 }}
                                                disabled={this.state.specsVal}
                                                className='needInput'
                                                value={this.state.maxSaleNum} onChange={(e) => {
                                                    this.setState({ maxSaleNum: e.target.value })
                                                }} />

                                            {
                                                !maxSaleNum ? (
                                                    <p className='tips warn'>不填则为无限大（无限库存）</p>
                                                ) : null
                                            }


                                        </div>
                                    </div>

                                )}
                            </div>



                            <div className='title'>
                                商品描述
                            </div>


                            <div ref={(el) => { this.messagesEnd = el; }} className='goods_Editor' id='goods_Editor' style={{ marginRight: '45px', marginTop: '20px' }}>
                                <Editor goodsContent={goodsContent} updateEditor={this.getEditor} ref='edom' bars={EditorBar} scrollBottom={() => { this.scrollToBottom() }} />
                            </div>


                            <div className='line flex alignCenter contrlBtn'>

                                <Button onClick={() => { this.addGoods(); }} className='themeBtn'>
                                    {
                                        props.location.state && props.location.state.isEditor ? '编辑' : '确定'
                                    }
                                </Button>

                                <Button>取消</Button>
                            </div>
                        </>
                    )
                }







            </div>
        )
    }
}